import { render, staticRenderFns } from "./inform.vue?vue&type=template&id=4c7d8e48&scoped=true"
import script from "./inform.vue?vue&type=script&lang=js"
export * from "./inform.vue?vue&type=script&lang=js"
import style0 from "./inform.vue?vue&type=style&index=0&id=4c7d8e48&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7d8e48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7d8e48')) {
      api.createRecord('4c7d8e48', component.options)
    } else {
      api.reload('4c7d8e48', component.options)
    }
    module.hot.accept("./inform.vue?vue&type=template&id=4c7d8e48&scoped=true", function () {
      api.rerender('4c7d8e48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/configure/components/inform.vue"
export default component.exports